import * as React from "react";
import { GridOverlay } from "@mui/x-data-grid";
import AnimationPage from "../../shared/animation-page/AnimationPage";

const GTableLoadingState = React.forwardRef(
  function GridLoadingOverlay(props, ref) {
    return (
      <GridOverlay ref={ref} {...props}>
        <AnimationPage variant="transparent" />
      </GridOverlay>
    );
  }
);

export default GTableLoadingState;
